"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.iActivityDetails = exports.iActivity = exports.iActivityType = void 0;
const t = require("io-ts");
exports.iActivityType = t.interface({
    id: t.number,
    name: t.string,
    groupName: t.string,
    order: t.number,
    featureId: t.union([t.number, t.null])
});
exports.iActivity = t.intersection([
    t.interface({
        activityType: t.number,
        name: t.string,
        timestamp: t.string,
        email: t.string,
        id: t.string,
        project: t.union([t.string, t.null])
    }),
    t.partial({
        metadata: t.union([
            t.record(t.string, t.union([t.string, t.number, t.boolean, t.null])),
            t.null
        ])
    })
]);
const iUserActivity = t.intersection([
    exports.iActivity,
    t.interface({
        type: t.literal('USER_ACTIVITY'),
        targetUser: t.union([t.string, t.null])
    })
]);
const iProjectActivity = t.intersection([
    exports.iActivity,
    t.interface({
        type: t.literal('PROJECT_ACTIVITY'),
        copiedFromId: t.union([t.number, t.null]),
        copiedFrom: t.union([t.string, t.null])
    })
]);
const iSokobidActivity = t.intersection([
    exports.iActivity,
    t.interface({
        type: t.literal('SOKOBID_ACTIVITY'),
        bidUuid: t.string,
        briefcaseUuid: t.string
    })
]);
const iModelspaceActivity = t.intersection([
    exports.iActivity,
    t.interface({
        type: t.literal('MODELSPACE_ACTIVITY'),
        target: t.string
    })
]);
const iFileActivity = t.intersection([
    exports.iActivity,
    t.interface({
        type: t.literal('FILE_ACTIVITY'),
        fileUuid: t.union([t.string, t.null]),
        targetUuid: t.union([t.string, t.null]),
        fileName: t.union([t.string, t.null])
    })
]);
exports.iActivityDetails = t.union([
    iUserActivity,
    iProjectActivity,
    iSokobidActivity,
    iModelspaceActivity,
    iFileActivity
]);
//# sourceMappingURL=activity.js.map